<template>
  <div id="app">
    <navigation></navigation>
    <router-view />
    <footerPage></footerPage>
  </div>
</template>

<script>
import Navigation from "@/components/navigation/index.vue";
import footerPage from "@/components/footer/index.vue";
export default {
  components: {
    Navigation,
    footerPage,
  },
  computed: {
    isAccountPage() {
      return ["conditions", "privacy", "account"].includes(this.$route.name);
    },
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="less">
@import "./assets/css/reset.css";
@import "./assets/css/common.css";
</style>
